<div class="footer-info">
    <div class="copyright-info">
        <div class="logo">
            <a
                *ngIf="currentUser; else signFooterLogo"
                href="https://appodeal.com/?stop&utm_campaign=%5BDES%5D%20Dashboard%20-%20testing&utm_source=dashboard"
                target="_blank"
            >
                <svg-image name="appodeal-new-logo" class="logo-icon"></svg-image>
            </a>
            <ng-template #signFooterLogo>
                <a href="https://www.appodeal.com/">
                    <svg-image name="appodeal-new-logo" class="logo-icon"></svg-image>
                </a>
            </ng-template>
            <div class="company-name">
                &copy; <span>{{ currentYear }}</span> Appodeal Inc.
            </div>
        </div>

        <ul class="reset-list docs-links">
            <li class="link">
                <a [href]="termsLink">{{ 'footer.docs.termsOfService' | i18next }}</a>
            </li>
            <li class="link">
                <a href="/privacy-policy">{{ 'footer.docs.privacyPolicy' | i18next }}</a>
            </li>
            <li class="link">
                <a href="/sdk-license-agreement">{{ 'footer.docs.license' | i18next }}</a>
            </li>
        </ul>
        <span class="version">v{{ buildInfo?.version }} (build: {{ buildInfo?.release }})</span>
    </div>
    <div class="footer-controls">
        <ng-container *ngIf="demo.isDemoHost">
            <leave-demo-account *ngIf="bridgeService.isUserLoggedIn() | async; else footerSignUpBtn"></leave-demo-account>
            <ng-template #footerSignUpBtn>
                <button class="button button--primary" (click)="navigateToSignFromDemoUpPage()">
                    {{ 'footer.btns.signUp' | i18next }}
                </button>
            </ng-template>
        </ng-container>

        <div class="footer-controls__lang">
            <svg-image name="language"></svg-image>
            <language-switcher *ngIf="isPageWithoutHeader" [dropDownView]="isPageWithoutHeader"></language-switcher>
        </div>
    </div>
</div>
